import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2 } from "lucide-react";

interface StickyOnboardingFooterProps {
  children: React.ReactNode;
  buttonText: string;
  onClick: () => void;
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  buttonTestId?: string;
}

const StickyOnboardingFooter = ({
  children,
  buttonText,
  onClick,
  disabled = false,
  isLoading = false,
  loadingText = "Salvando...",
  buttonTestId = "sticky-footer-button"
}: StickyOnboardingFooterProps) => {
  return (
    <div className="flex flex-col min-h-[calc(100dvh-180px)]">
      {/* Content area - scrollable */}
      <div className="flex-1 overflow-y-auto scrollbar-none pb-4">
        {children}
      </div>
      
      {/* Sticky footer */}
      <div className="sticky bottom-0 left-0 right-0 pt-4 pb-6 bg-gradient-to-t from-black via-black/95 to-transparent">
        <div className="max-w-3xl mx-auto px-4">
          <Button 
            onClick={onClick}
            disabled={disabled || isLoading}
            variant="brand-gradient"
            className="w-full h-12 text-base font-medium"
            data-testid={buttonTestId}
          >
            {isLoading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                {loadingText}
              </>
            ) : (
              <>
                {buttonText}
                <span className="ml-2">→</span>
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default StickyOnboardingFooter;
